<div class="h-full w-full aligner-start pl-2">
  <y42-column-type-icon [type]="params.value"></y42-column-type-icon>
</div>
